export default __webpack_public_path__ + "static/media/exercises-icon.4670e6cc.png";